export enum SocialNetworkReactions {
  LIKE = 'LIKE',
  LOVE = 'LOVE',
  GENIUS = 'GENIUS',
  SUPPORT = 'SUPPORT',
  FUNNY = 'FUNNY',
}
